<div *ngIf="(loaded$ | async); else loading" class="content">
    <affichage-hierarchique [listeColonnesAAfficher]="listeColonnes" [listeCartesHierarchiques]="[carteDroits]"></affichage-hierarchique>
</div>
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>